import axios from 'axios';
import { CLIPBOARD_FILTER_ALL } from '../../components/common/clipboard/clipboard-constants';

export {
  CLIPBOARD_TYPES,
  CLIPBOARD_FILTER_ALL,
  CLIPBOARD_SORT_NEWEST,
  CLIPBOARD_SORT_OLDEST,
  CLIPBOARD_ALL_META,
  CLIPBOARD_TYPE_META,
} from '../../components/common/clipboard/clipboard-constants';

const BASE_URL = '/clipboard-items';

export async function fetchClipboardItems(type = null) {
  const params = type && type !== CLIPBOARD_FILTER_ALL ? { type } : {};
  const { data } = await axios.get(BASE_URL, { params });
  return data;
}

export async function createClipboardItem(payload) {
  const { data } = await axios.post(BASE_URL, payload);
  return data;
}

export async function updateClipboardItem(id, payload) {
  const { data } = await axios.put(`${BASE_URL}/${id}`, payload);
  return data;
}

export async function deleteClipboardItem(id) {
  await axios.delete(`${BASE_URL}/${id}`);
}
